var _ = require('underscore');
var TorsoListView = require('backbone-torso/modules/ListView');
var appointmentQuestionnaireListTemplate = require('./appointmentQuestionnaireListTemplate.hbs');
var PortalDataService = require('./../data-utils/PortalDataService');
var QuestionnaireSummaryItemView = require('./../questionnaire/QuestionnaireSummaryItemView');

/**
 * The AppointmentQuestionnaireListView shows the list of appointment questionnaires that were taken for an appointment.
 *
 * @class AppointmentQuestionnaireListView
 *
 * @constructor
 */
module.exports = TorsoListView.extend(PortalDataService.mixin({
  tagName: 'div',
  template: appointmentQuestionnaireListTemplate,
  itemContainer: 'questionnaire-summary',
  itemView: QuestionnaireSummaryItemView,

  dataModels: [
    {
      alias: 'appointment',
      modelType: 'appointment',
      usePull: true,
      id: function() {
        return this._appointmentExternalId;
      }
    },
    {
      alias: 'surveyResponse',
      collectionType: 'surveyResponse',
      ids: function() {
        var appointmentQuestionnaireNames = this.getFetchedProperty('appointment', 'externalAppointment.surveyResponses');
        return _.values(appointmentQuestionnaireNames);
      },
      dependencies: ['appointment:externalAppointment.surveyResponses']
    }
  ],

  /**
   * @method initialize
   * @param options {Object}
   *   @param options.patientVecnaId {String} the vecna id of the patient to get the questionnaires for.
   *   @param options.appointmentExternalId {String} the external id of the appointment to get the questionnaires for.
   * @override
   */
  initialize: function(options) {
    this._patientVecnaId = options.patientVecnaId;
    this._appointmentExternalId = options.appointmentExternalId;

    var surveyResponses = this.getPrivateCollection('surveyResponse');
    this.setCollection(surveyResponses);

    this.on('fetched:surveyResponse', this._triggerQuestionnairesUpdatedEvent);
  },

  /**
   * @method hasQuestionnaires
   * @return {Boolean} true if there are questionnaires to display, false otherwise.
   */
  hasQuestionnaires: function() {
    var appointmentQuestionnaireNames = this.getFetchedProperty('appointment', 'externalAppointment.surveyResponses');
    return !_.isEmpty(appointmentQuestionnaireNames);
  },

  /**
   * Trigger 'questionnaires-updated' event for any listening views
   * @method _triggerQuestionnairesUpdatedEvent
   * @private
   */
  _triggerQuestionnairesUpdatedEvent: function() {
    this.trigger('questionnaires-updated');
  }
}));
